module.exports = __webpack_public_path__ + "static/tuv-mark-ae8ffaa22889eb1e8b9ccd60b85fd20b.png";